import { initModule } from './init-module';

initModule();

export { DocumentCenterRoutes } from './document-center.routes';
export { DocumentCenterComponent } from './components/document-center.component';
export { documentCenter } from './document-center.config';
